import { useEffect, useState } from 'react';
import { api } from '../App';

let cache = null;
let pending = null;

// Specialty tags per category, served by GET /api/categories/specialties.
export function useSpecialties() {
  const [data, setData] = useState(cache || {});
  useEffect(() => {
    if (cache) return;
    pending = pending || api.get('/categories/specialties').then((r) => { cache = r.data; return cache; });
    pending.then(setData).catch(() => setData({}));
  }, []);
  return data;
}

export function specialtyName(data, id) {
  for (const items of Object.values(data)) {
    const hit = items.find((s) => s.id === id);
    if (hit) return hit.name;
  }
  return id;
}
